import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { PROPERTY } from '@clooper/core';
import { faBuilding, faUsersClass  } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-property-type-welcome-modal',
  templateUrl: './property-type-welcome-modal.component.html',
  styleUrls: ['./property-type-welcome-modal.component.scss']
})
export class PropertyTypeWelcomeModalComponent implements OnInit {
  occupancy_types = PROPERTY.OCCUPANCY_TYPES;
  icons = {
    building: faBuilding,
    usersClass: faUsersClass
  }
  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    ) { }

  ngOnInit(): void {
  }
  
  navigeToProperty(type: string) {
    this.bsModalRef.hide()
    this.bsModalRef.onHidden?.subscribe(() => { 
      const queryParams = { type}
      this.router.navigate(['/properties/create/0'], {queryParams}).then(() => {
        // window.location.reload()
      });
    });
  }
}
